webpackJsonp([11102216829691],{

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(9);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _WebsolutionsSidebar = __webpack_require__(14);
	
	var _WebsolutionsSidebar2 = _interopRequireDefault(_WebsolutionsSidebar);
	
	var _BranddevelopmentSidebar = __webpack_require__(12);
	
	var _BranddevelopmentSidebar2 = _interopRequireDefault(_BranddevelopmentSidebar);
	
	var _DigitalmarketingSidebar = __webpack_require__(13);
	
	var _DigitalmarketingSidebar2 = _interopRequireDefault(_DigitalmarketingSidebar);
	
	var _Fill = __webpack_require__(5);
	
	var _Fill2 = _interopRequireDefault(_Fill);
	
	var _Divider = __webpack_require__(6);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var query = exports.query = '** extracted graphql fragment **';
	
	var InfluencersMarketing = function InfluencersMarketing(_ref) {
	  var iambanner = _ref.data.iambanner;
	  return _react2.default.createElement(
	    'section',
	    null,
	    _react2.default.createElement(
	      'article',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'full-Width', style: { alignItems: 'flex-start' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-75 paddingRight mobBottommargin' },
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'block' } },
	            _react2.default.createElement(
	              'h1',
	              { className: 'smallerHone' },
	              'Influencers and Affiliated Marketing'
	            ),
	            _react2.default.createElement('img', { src: _Divider2.default, alt: 'Nisadhya - Divider', style: { margin: '0.75rem 0' } }),
	            _react2.default.createElement(
	              'p',
	              { className: 'smallerHone' },
	              _react2.default.createElement(
	                'span',
	                { className: 'gradient' },
	                'Case studies such as these inspire and motivate us.'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'See how businesses similar to yours are growing with Digital Marketing.'
	            ),
	            _react2.default.createElement('div', { style: { backgroundImage: 'url("' + iambanner.sizes.src + '"), url("' + iambanner.sizes.tracedSVG + '")', backgroundPosition: 'center', backgroundSize: 'cover', minHeight: '50vh', marginBottom: '1.45rem' } }),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              'What your brand needs is not the \u2018biggest\u2019 influencers but the \u2018right\u2019 influencers that will endorse your search visibility, brand awareness and engagement. We ensure that your brand works with the \u2018right\u2019 people to use their influence and mention your brand to potential customers to form a mutually beneficial relationship.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'half-Width-25 service-sidebar' },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '2.5rem' } },
	            _react2.default.createElement(_DigitalmarketingSidebar2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '2.5rem' } },
	            _react2.default.createElement(_WebsolutionsSidebar2.default, null)
	          ),
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_BranddevelopmentSidebar2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = InfluencersMarketing;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-digital-marketing-influencers-and-affiliated-marketing-js-08f11aea97efd5c08684.js